<template>
  <v-dialog
    v-model="showWindow"
    scrollable
    max-width="1000"
    max-height="90%"
    min-width="90%"
  >
    <v-card height="100%" :loading="loading">
      <v-card-text class="pt-5">
        <h2 class="">{{ $t("common.images") }}</h2>
        <template v-if="item && item.images">
          <template v-for="image in item.images">
            <v-row>
              <v-col class="mb-0 pb-0">
                <v-img
                    class="mb-0"
                    :src="backendURL+'/levam/'+image.name"
                ></v-img>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mb-0 pb-0 text-right">
                <v-btn
                    elevation="0"
                    min-width="36"
                    min-height="36"
                    @click="removeImage(image.id)" :disabled="loading"
                    color="red lighten-2"
                    class="mb-4 ml-3 px-0 white--text"
                    :title="$t('common.remove')"
                >
                  <v-icon small>$trash</v-icon>
                </v-btn>

              </v-col>
            </v-row>
          </template>
        </template>
        <template v-else>
          {{ $t("common.no_images") }}
        </template>
            <v-file-input
              :loading="loading"
              :disabled="loading"
              :key="fileInputComponentKey"
              chips
              multiple
              prepend-icon="fa-paperclip"
              :label="$t('common.upload')"
              @change="uploadImage"
              accept="image/png, image/jpeg"
            ></v-file-input>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CommonMixin from "@/mixins/common";
export default {
  name: "OrderItemImagesWindow",
  mixins: [CommonMixin],
  props: {
    show: false,
    loading: false,
    item: null,
  },
  data() {
    return {
      fileInputComponentKey: 0,
    };
  },
  computed: {
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
    prefix(){
      return process.env.VUE_APP_IMG_PREFIX;
    }
  },
  methods:{
    uploadImage(files){
      this.$emit("store", files);
    },
    removeImage(id){
      this.$emit("remove", id);
    }
  },
  watch:{
    show(to){
      if(!to){
        this.$emit("hide", false);
        this.fileInputComponentKey++;
      }
    },
    loading(to){
      if(!to){
        this.fileInputComponentKey++;
      }
    }
  }
};
</script>

<style scoped></style>
